export function getCurrentPermissions() {
  try {
    const permissions = JSON.parse(localStorage.getItem("x-permissions") || "[]");
    return Array.isArray(permissions) ? permissions.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
}

export function isBoletimAdministrator() {
  const role = localStorage.getItem('x-role-key');
  return role ? role === 'administrador' : localStorage.getItem('x-user-tipo') === 'admin';
}

export function hasPermission(permission) {
  const permissions = getCurrentPermissions();
  if (permissions.includes(permission)) return true;
  return (permission === "users.view" && permissions.includes("users.manage")) ||
    (permission === "roles.view" && (
      permissions.includes("roles.manage") || permissions.includes("users.manage")
    ));
}
